import React from 'react';
import { Button, Form, FormGroup, Label, Input, FormText, Container, Row, Col } from 'reactstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import logoImg from '../img/logo.png';
import ReactTable from "react-table";
import "react-table/react-table.css";
import withTracker from '../containers/Full/withTracker';
import {withRouter, Link} from "react-router-dom";
import {connect} from 'react-redux';


import matchSorter from "match-sorter";

import '../styles/sideProfile.scss';
import {request, update} from '../modules/actions/request';
import profileIcon from "../img/profile.png";

class RequestList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.showRequestList = this.showRequestList.bind(this);
    }

    componentDidMount() {
        this.showRequestList();
    }

    showRequestList() {
        let that = this; //this는 dashboardBuyer component!
        // console.log("this state is what??", this);
        axios.post('https://spice-api.pearlfall.vercel.app'+`/requests/list`, {})
            .then(function (response) {
                // console.log('response request list', response);
                that.setState({ //this.setState 하면 undefined나오는데, 이유는 then안에서 불리는 this는 dashboardBuyer component를 가리키지 않음
                    //따라서 that에 this를 저장해서 여기서 불러야함
                    data: response.data.request,
                });
            })
            .catch(function (error) {
                console.log(error);
            })
    }

    async updateHandler(requestId, status){
        // console.log("requestId", requestId);
        var payload = {"requestId": requestId , "status": status};
        let result = await this.props.dispatch(update(payload));
        // console.log("what is request??", result);
        if(result.status==="Success"){
            Swal.fire({
                title: 'Success!',
                // text: 'Successfully cancelled. If you want to reschedule, submit request again.',
                type: 'success',
                confirmButtonText: 'close'
            })
                .then(()=>{
                    console.log("Dismissed");
                    window.location.assign('/dashboard/request');
                });
        }
    }

    // async updateAccept(){
    //     console.log("requestId", this.state.data);
    //     var payload = [{"requestId": this.state.data.requestId , "status": "Accepted"}];
    //     let result = await this.props.dispatch(update(payload));
    //     console.log("what is request??", result);
    // }

    // async updateReject(){
    //     var payload = [{"requestId": this.state.data.requestId , "status": "Rejected"}];
    //     let result = await this.props.dispatch(update(payload));
    //     console.log("what is request??", result);
    // }


    render() {
        // console.log("request list", this.state.data);
        return (
            <div className="profile-right">

                <h1 className="text-center">
                    Here are new requests for you!
                </h1>
                <Row>
                    <Col md={1}></Col>
                    <Col md={10}>
                        <ReactTable style={{"margin-top":"30px"}}
                                    data={this.state.data}
                                    filterable
                                    defaultFilterMethod={(filter, row) =>
                                        String(row[filter.id]) === filter.value}
                                    columns={[
                                        {
                                            Header: "Buyer",
                                            accessor: "buyerName",
                                            width: 120,
                                            sortable: true,
                                            filterAll: true,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: [filter.id]}),

                                        },
                                        {
                                            Header: "Request Date",
                                            id: 'RequestDate',
                                            accessor: "date",
                                            width: 130,
                                            sortable: true,
                                            filterAll: true,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: [filter.id]}),
                                            Cell: (data) => {
                                                var date = data.row.RequestDate;
                                                return (
                                                    <div>{date ? date.slice(0,10) : ''}</div>);
                                            }

                                        },
                                        {
                                            Header: "Subject",
                                            accessor: "subject",
                                            width: 150,
                                            sortable: true,
                                            filterAll: true,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: [filter.id]}),

                                        },
                                        {
                                            Header: "Message",
                                            accessor: "message",
                                            width: 500,
                                            sortable: true,
                                            filterAll: true,
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {keys: [filter.id]}),

                                        },
                                        {
                                            Header: "Accept",
                                            id: 'Accept',
                                            width: 85,
                                            filterable: false,
                                            Cell: (data) => {
                                                return (
                                                    <div className="text-center">
                                                        <button
                                                            onClick={()=>this.updateHandler(data.original.requestId, "Accepted")}
                                                        >
                                                            Accept
                                                        </button>
                                                    </div>
                                                );
                                            }
                                        },
                                        {
                                            Header: "Reject",
                                            id: 'Reject',
                                            width: 85,
                                            filterable: false,
                                            Cell: (data) => {
                                                return (
                                                    <div className="text-center">
                                                        <button
                                                            onClick={()=>this.updateHandler(data.original.requestId, "Rejected")}
                                                        >
                                                            Reject
                                                        </button>
                                                    </div>
                                                );
                                            }
                                        },
                                        {
                                            Header: "Detail",
                                            id: 'Detail',
                                            width: 85,
                                            filterable: false,
                                            Cell: (data) => {
                                                return (
                                                    <div className="text-center">
                                                        <Link
                                                            className="btn btn-sm btn-outline-secondary m-0"
                                                            to = {'/dashboard/profile/'+data.row.buyerName}
                                                        >
                                                            <img src={profileIcon} className="profile-icon"/>
                                                        </Link>
                                                    </div>
                                                );
                                            }
                                        },

                                    ]}
                                    defaultPageSize={10}
                                    className="-striped -highlight"
                        />
                    </Col>
                    <Col md={1}></Col>
                </Row>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        user: store.auth.user
    };
}


export default withRouter(connect(mapStateToProps)(RequestList));
